import React from 'react'
import { graphql, useFragment } from 'react-relay/hooks'
import { Box, Anchor, Tooltip, Text } from 'elements'
import { useStorage } from 'hooks'

const integrationSources = {
  'qb:json': 'QBO',
  'xero:json': 'Xero',
}

export default function ReportSources(props) {
  const report = useFragment(
    graphql`
      fragment ReportSources_report on Report {
        id
        status
        reportUserFiles {
          nodes {
            type
            userFile {
              id
              rowId
              kind
              name
              key
            }
          }
        }
      }
    `,
    props.report,
  )

  const storage = useStorage()

  const pending = report?.status === 'DRAFT'

  // report will be null if the row has been permanently deleted.
  //don't display sources until report is complete
  if (!report || pending) {
    return null
  }

  const tooltipId = `${report.id}-sources`
  const { reportUserFiles } = report
  const sourceFiles = reportUserFiles.nodes.filter((file) => file.type === 'SOURCE')

  const sourceFileKind = sourceFiles?.[0]?.userFile?.kind
  const generalKind = sourceFileKind ? sourceFileKind.split(':').slice(0, 2).join(':') : null

  if (integrationSources[generalKind]) {
    return (
      <Text whiteSpace="nowrap" color="neutral.0" fontSize="large">
        {integrationSources[generalKind]}
      </Text>
    )
  }

  return (
    <>
      {
        sourceFiles && sourceFiles.length > 0 &&        
        <Anchor whiteSpace="nowrap" color="neutral.0" fontSize="large" data-tip data-for={tooltipId}>
          {sourceFiles.length} files
        </Anchor>
      }
      <Tooltip clickable id={tooltipId}>
        <Box display="flex" flexDirection="column">
          {sourceFiles.map(({ userFile }) => (
            <Anchor
              key={userFile.id}
              color="neutral.0"
              mb="small"
              href={storage.url(userFile.rowId)}
              // stop clicks from triggering outer anchor
              onClick={(e) => e.stopPropagation()}
            >
              {userFile.name}
            </Anchor>
          ))}
        </Box>
      </Tooltip>
    </>
  )
}
